export const urlInfo = () => {
    const arr = window.location.pathname.split('&');
    const viewPath = arr[0];
    let params = undefined;
    if (arr.length === 2) {
        params = arr[1];
        const arrParams = params.split('/');

        if (arrParams.length === 2) return { viewPath, appId: Number.parseInt(arrParams[1]) };
        return { viewPath, appId: Number.parseInt(arrParams[1]), depId: Number.parseInt(arrParams[2]) };
    }
    return { viewPath };
};
